import { createContext } from 'react';
import { Displays, DisplaysValues } from '../type';
import { Brawler, Map } from '../common.type';

export const LayoutContext = createContext<{
  displayMode: DisplaysValues;
  brawlers: Brawler[];
  maps: Map[];
}>({ displayMode: Displays.LANDSCAPE, brawlers: [], maps: [] });
